'use client';

import { tw } from '../../utils';

export const Skeleton: React.FC = () => {
  return (
    <div className='absolute inset-0'>
      <div
        className={tw(
          'bg-rainbow background-animate h-full w-full animate-pulse opacity-50',
        )}
      />
    </div>
  );
};
